import { settlementTexts } from 'consts/text';

export type ChildSettlementDetailsTabValue = 'MONTHLY_SETTLEMENT' | 'MANUAL_SETTLEMENT';
export const ChildSettlementDetailsUrlSearchKey = 'settlementTabKey';

export const ChildSettlementDetailsMenuItems = [
    {
        key: 'MONTHLY_SETTLEMENT',
        label: settlementTexts.children.details.monthlySettlement,
    },
    {
        key: 'MANUAL_SETTLEMENT',
        label: settlementTexts.children.details.manualSettlement,
    },
];
